import { createSelector } from 'reselect';

import { EOfferState } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { TState } from '~/src/store';

export const selectNewOrViewedOffers = createSelector(
    (state: TState) => state.specOffers.offers,
    (offers) => {
        const stoppers = offers
            .filter(({ state, paySum }) => (state === EOfferState.NEW || state === EOfferState.VIEWED) && !paySum);

        return {
            stopper: stoppers[0],
            hasOtherOffers: stoppers.length > 1,
        };
    },
);
